import { useState } from 'react'
import { Archive } from 'lucide-react'
import Modal from '../../../components/ERP/Modal/Modal'
import { patientService } from '../../../services/patientApi'
import './PatientsPage.css'

function ArchivePatientModal({ isOpen, patientId, patientName, onClose, onArchived }) {
  const [reason, setReason] = useState('saida')
  const [justification, setJustification] = useState('')
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState('')

  const submit = async (event) => {
    event.preventDefault()
    setSaving(true)
    setError('')
    try {
      await patientService.archive(patientId, { reason, justification })
      onArchived()
      onClose()
    } catch (err) {
      setError(err.response?.data?.message || 'Não foi possível arquivar o prontuário')
    } finally {
      setSaving(false)
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Arquivar prontuário"
      subtitle="Saída ou óbito"
      icon={<Archive size={22} />}
      size="medium"
      footer={(
        <button type="submit" form="archive-patient-form" disabled={saving}>
          {saving ? 'Arquivando...' : 'Arquivar paciente'}
        </button>
      )}
    >
      <form id="archive-patient-form" onSubmit={submit}>
        {error && <p className="patients-alert-strip">{error}</p>}
        <p className="patients-note">Paciente: <strong>{patientName}</strong></p>
        <div className="patients-form-grid">
          <div>
            <label>Motivo *</label>
            <select value={reason} onChange={(e) => setReason(e.target.value)}>
              <option value="saida">Saída / alta</option>
              <option value="obito">Óbito</option>
            </select>
          </div>
          <div>
            <label>Justificativa *</label>
            <textarea
              required
              minLength={5}
              rows={4}
              value={justification}
              onChange={(e) => setJustification(e.target.value)}
              placeholder="Descreva o motivo do arquivamento"
            />
          </div>
        </div>
      </form>
    </Modal>
  )
}

export default ArchivePatientModal
